import { cn } from "@/lib/utils";
import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";

export function MockLabel({
  icon: Icon,
  children,
  aside,
  className,
}: {
  icon?: LucideIcon;
  children: ReactNode;
  aside?: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "mb-3 flex items-center justify-between gap-2 text-[11px] font-medium text-neutral-500",
        className,
      )}
    >
      <span className="inline-flex min-w-0 items-center gap-1.5">
        {Icon ? <Icon className="size-3 shrink-0" /> : null}
        <span className="truncate">{children}</span>
      </span>
      {aside ? (
        <span className="shrink-0 font-normal text-neutral-400">{aside}</span>
      ) : null}
    </div>
  );
}

export function MockFrame({
  icon,
  label,
  aside,
  className,
  children,
}: {
  icon?: LucideIcon;
  label: ReactNode;
  aside?: ReactNode;
  className?: string;
  children: ReactNode;
}) {
  return (
    <div className={cn("w-full max-w-[280px]", className)}>
      <MockLabel icon={icon} aside={aside}>
        {label}
      </MockLabel>
      {children}
    </div>
  );
}
